import React from 'react';

const DeletedMessage = () => <div className='chatterbox-tombstone'>This note was deleted</div>;

export default DeletedMessage;
